"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.constantRoutes = exports.asyncRoutes = void 0;
exports.resetRouter = resetRouter;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _vue = _interopRequireWildcard(require("vue"));
var _vueRouter = _interopRequireDefault(require("vue-router"));
var _layout = _interopRequireDefault(require("@/layout"));
var _uc = _interopRequireDefault(require("./modules/uc"));
var _basicInfo = _interopRequireDefault(require("./modules/basicInfo"));
var _userAuth = _interopRequireDefault(require("./modules/userAuth"));
var _log = _interopRequireDefault(require("./modules/log"));
var _config = _interopRequireDefault(require("./modules/config"));
var _userTask = _interopRequireDefault(require("./modules/userTask"));
var _goods = _interopRequireDefault(require("./modules/goods"));
var _drinkCard = _interopRequireDefault(require("./modules/drinkCard"));
var _memberEquities = _interopRequireDefault(require("./modules/memberEquities"));
var _order = _interopRequireDefault(require("./modules/order"));
var _job = _interopRequireDefault(require("./modules/job"));
var _memberManagement = _interopRequireDefault(require("./modules/memberManagement"));
var _shopManagement = _interopRequireDefault(require("./modules/shopManagement"));
var _evaluate = _interopRequireDefault(require("./modules/evaluate"));
var _DecorationManagement = _interopRequireDefault(require("./modules/DecorationManagement"));
var _evaluateManifest = _interopRequireDefault(require("./modules/evaluateManifest"));
var _GaGaCommunity = _interopRequireDefault(require("./modules/GaGaCommunity"));
var _GoodsActivity = _interopRequireDefault(require("./modules/GoodsActivity.js"));
var _zdyDragging = _interopRequireDefault(require("./modules/zdyDragging"));
var _activity = _interopRequireDefault(require("./modules/activity"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
_vue.default.use(_vueRouter.default);
/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 **/

var constantRoutes = exports.constantRoutes = [{
  path: '/redirect',
  component: _layout.default,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/redirect/index'));
      });
    }
  }]
}, {
  path: '/login',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/login/index'));
    });
  },
  hidden: true
}, {
  path: '/wxWorkLoginCallBack',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/login/WxWorkLoginCallbackPane'));
    });
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/404'));
    });
  },
  hidden: true
}, {
  path: '/guide',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/guide'));
    });
  },
  hidden: true
}, {
  path: '/',
  component: _layout.default,
  redirect: '/dashboard',
  name: 'index',
  meta: {
    title: '首页'
  },
  children: [{
    path: 'dashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/dashboard/home'));
      });
    },
    name: 'dashboard',
    meta: {
      title: '首页',
      icon: 'home'
    }
  }, {
    path: 'changePassword',
    hidden: true,
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/uc/ChangePassword'));
      });
    },
    name: 'changePassword',
    meta: {
      title: '修改密码',
      icon: ''
    }
  }]
}, {
  path: '/HelpCenter',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/help/HelpCenter'));
    });
  },
  name: 'HelpCenter',
  redirect: '/introduction',
  hidden: true,
  children: [{
    path: "/introduction",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/help/views/introduction"));
      });
    }
  }, {
    path: "/product",
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require("@/views/help/views/product"));
      });
    }
  }]
},
// 自定义页面装修配置页（独立全屏，脱离主框架 Layout）
{
  path: "/zdy-dragging/configPage",
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require("@/views/zdy_dragging/config/configPage.vue"));
    });
  },
  name: "ConfigPage",
  hidden: true
}];
var asyncRoutes = exports.asyncRoutes = [_basicInfo.default, _userTask.default, _shopManagement.default, _goods.default, _drinkCard.default, _memberEquities.default, _order.default, _GoodsActivity.default, _evaluate.default, _evaluateManifest.default, _DecorationManagement.default, _GaGaCommunity.default, _memberManagement.default, _job.default, _userAuth.default, _log.default, _uc.default, _config.default, _zdyDragging.default,
//goodsRouter,
_activity.default];
var createRouter = function createRouter() {
  return new _vueRouter.default({
    // mode: 'history', // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();
function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
var _default = exports.default = router;